import { SelectOption } from "../../../../../components/newUI/select";

export const DEFAULT_PHONE_TYPE: SelectOption = {
  value: "bcd697a8-ef4c-4f91-bb8f-891df1ddfba0",
  label: "Mobile",
};

export const DEFAULT_ADDRESS_TYPE = "12F73C73-89E5-4F69-9F14-ED7A1FFC3080";

export const ADDRESS_TYPES: SelectOption[] = [
  {
    label: "Billing address",
    value: DEFAULT_ADDRESS_TYPE,
  },
  {
    label: "Shipping address",
    value: "3DD3A326-09C5-4E0A-93FC-6B439A4B6CAC",
  },
];

export const PRIMARY_EMAIL_TOOLTIP_ID = "edit-contact-primary-email-tooltip";
